import { AfterViewInit, Component, ElementRef, ViewChild } from '@angular/core';
import { AppLayoutDefaultService } from './default.service';
import { videoPreview } from '../../../assets/video/background';
import { MatSidenav } from '@angular/material/sidenav';
import { ApiAuthService } from '@app/api';

@Component({
  selector: 'app-layout-default',
  styleUrls: ['./default.component.scss'],
  templateUrl: './default.component.html',
})
export class AppLayoutDefaultComponent implements AfterViewInit {
  @ViewChild('videoPreview', { static: false }) _videoPreview?: ElementRef;
  @ViewChild('size') _side?: MatSidenav;
  @ViewChild('video', { static: false }) _video?: ElementRef;

  constructor(
    private _appLayoutDefault: AppLayoutDefaultService,
    private _apiAuth: ApiAuthService,
  ) {}

  private _videoVisible: boolean = true;

  get videoVisible() {
    return this._videoVisible;
  }

  get logged() {
    return !!this._apiAuth.user;
  }

  get sideOpened() {
    return this._appLayoutDefault.sideOpened;
  }

  set sideOpened(sideOpened) {
    this._appLayoutDefault.sideOpened = sideOpened;
  }

  get videoPreviewUrl() {
    return 'data:image/png;base64,' + videoPreview;
  }

  get videoElement() {
    return this._video?.nativeElement as HTMLVideoElement;
  }

  logout() {
    this._apiAuth.logout().subscribe();
  }

  ngAfterViewInit() {
    this._appLayoutDefault.videoChanged.subscribe((result) => {
      this._videoVisible = result;
      if (result) {
        setTimeout(() => {
          if (this.videoElement) {
            if (this.videoElement.readyState == 4) {
              this._hideVideoPreview();
            } else {
              this.videoElement.oncanplay = () => this._hideVideoPreview();
            }
          }
        });
      }
    });
  }

  sideClose() {
    return (this._appLayoutDefault.sideOpened = false);
  }

  private _hideVideoPreview() {
    this.videoElement.play().then();
    (this._videoPreview?.nativeElement as HTMLImageElement).style.opacity = '0';
  }
}
